import React, { useState, useEffect, useRef } from 'react';

// Calculates whole months elapsed since a given start date
const getMonthsSince = (startDate) => {
    const start = new Date(startDate);
    const now = new Date();

    let months = (now.getFullYear() - start.getFullYear()) * 12;
    months += now.getMonth() - start.getMonth();

    // If we haven't yet hit the day-of-month anniversary this month, don't count it
    if (now.getDate() < start.getDate()) {
        months -= 1;
    }

    return months;
};

const Counter = () => {
    const counters = [
        { value: 15, label: "Projects Delivered" },
        { value: 3, label: "Research Publications" },
        { value: 20, label: "Technologies Mastered" },
        { value: getMonthsSince("2018-06-11"), label: "Months of Experience" }
    ];
    return (
        <div id="colorlib-counter" className="colorlib-counters">
            <div className="colorlib-narrow-content">
                <div className="counter-grid">
                    {counters.map((item, index) => (
                        <CounterItem key={index} value={item.value} label={item.label} />
                    ))}
                </div>
            </div>
        </div>
    );
};

const CounterItem = ({ value, label }) => {
    const [count, setCount] = useState(0);
    const [inView, setInView] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.5 }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!inView) return;

        let start = 0;
        const duration = 2500;
        const increment = value / (duration / 16);
        const timer = setInterval(() => {
            start += increment;
            if (start >= value) {
                setCount(value);
                clearInterval(timer);
            } else {
                setCount(Math.floor(start));
            }
        }, 16);

        return () => clearInterval(timer);
    }, [inView, value]);

    return (
        <div ref={ref} className="counter-item">
            <span className="colorlib-counter">{count}+</span>
            <span className="colorlib-counter-label">{label}</span>
        </div>
    );
};

export default Counter;
